<template>
    <div class="marketing-configure-error-page">
        <div class="marketing-configure-error-page__header">
            <div class="marketing-configure-error-page__header-logo" @click="goToUrl('/home')">
                <CompassLogo type="logo" :width="160" />
            </div>
        </div>

        <div class="marketing-configure-error-page__content">
            <div class="marketing-configure-error-page__content-illustration">
                <img src="/ressources/logged/img/common/global-issues.svg" />
            </div>

            <div class="marketing-configure-error-page__content-title typographies-display-large">
                {{ $l10n.__('Une erreur est survenue') }}
            </div>

            <div
                class="marketing-configure-error-page__content-informations typographies-paragraph-x-large-regular"
                v-html="
                    $t.__('marketing.configure.MarketingConfigureErrorPage.error', { br: '<br />' })
                "
            />

            <div class="marketing-configure-error-page__content-buttons">
                <CompassButton
                    :label="$t.__('marketing.configure.MarketingConfigureErrorPage.retry')"
                    size="large"
                    @click="goToUrl('/marketing/configure')"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { goToUrl } from 'vueDir/helpers.js';

export default {
    methods: {
        goToUrl,
    },
};
</script>

<style lang="scss" scoped>
.marketing-configure-error-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;

    &__header {
        display: flex;
        align-items: center;
        width: 100%;
        padding: 0 var(--spacing-6);

        &-logo {
            width: 160px;
            cursor: pointer;
        }
    }

    &__content {
        margin: auto;

        &-illustration {
            text-align: center;
            margin-bottom: var(--spacing-5);
        }

        &-title {
            text-align: center;
            color: var(--colors-common-text-brand-secondary-blue);
            margin-bottom: var(--spacing-3);
        }

        &-informations {
            text-align: center;
            color: var(--colors-common-text-subtle-default);
            margin-bottom: var(--spacing-5);
        }

        &-buttons {
            display: flex;
            justify-content: center;
        }
    }
}
</style>
